<template>
  <div class="projects-index">
    <app-view-layout
      fluid
      header="Projekty wymagające akcji"
      :items-count="pagination.itemsLength"
    >
      <template #toolbarMenu>
        <ProjectsListToolbarMenu @search="fetchProjectsWithRequiredAction" />
      </template>

      <template #content>
        <ProjectsListSearchbar @search="fetchProjectsWithRequiredAction" />

        <v-fade-transition mode="out-in">
          <div
            v-if="projectsList.length"
            key="ProjectList"
          >
            <ProjectsList
              v-if="viewMode === 'list'"
              @fetch="fetchProjectsWithRequiredAction"
            />
            <ProjectsTable
              v-else
              @fetch="fetchProjectsWithRequiredAction"
            />
            <AppPagination @change="fetchProjectsWithRequiredAction" />
          </div>

          <AppEmptyList
            v-else
            key="emptyList"
            class="projects-index__empty"
            header="Nie znaleziono projektów oczekujących na twoją decyzję."
            text="Sprawdź sekcję twoje projekty oraz wszystkie projekty."
          />
        </v-fade-transition>
      </template>
    </app-view-layout>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import AppViewLayout from '@/components/Layout/AppViewLayout.vue';
import ProjectCard from '@/components/Projects/ProjectCard.vue';
import ProjectsListToolbarMenu from '@/components/Projects/ProjectsListToolbarMenu.vue';
import AppPagination from '@/components/UI/AppPagination.vue';
import AppEmptyList from '@/components/UI/AppEmptyList.vue';
import ProjectsListSearchbar from '@/components/Projects/ProjectsListSearchbar.vue';
import ProjectsList from '@/components/Projects/ProjectsList.vue';
import ProjectsTable from '@/components/Projects/ProjectsTable.vue';

export default {
  components: {
    AppViewLayout,
    ProjectCard,
    ProjectsListToolbarMenu,
    ProjectsListSearchbar,
    AppPagination,
    AppEmptyList,
    ProjectsList,
    ProjectsTable,
  },

  computed: {
    ...mapState('projects', [
      'projectsList',
      'viewMode',
    ]),
    ...mapState('pagination', ['pagination']),
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name !== 'project-single') vm.resetProjects();
      vm.fetchProjectsWithRequiredAction();
    });
  },

  beforeRouteLeave(to, from, next) {
    if (to.name !== 'project-single') this.resetProjects();
    next();
  },

  methods: {
    ...mapActions('dialog', ['showDialog', 'clearDialog']),
    ...mapActions('projects', [
      'fetchProjectsWithRequiredAction',
      'resetProjects',
    ]),
  },
};
</script>

<style lang="scss" scoped>
.projects-index {
  &__empty {
    min-height: calc(100vh - 220px);
  }
}
</style>
